module.exports = __webpack_public_path__ + "static/si_bigman-7dfbdb87af4bb758b022abdcf985e0c3.jpg";